import classNames from 'classnames';
import {ReactNode} from 'react';

import Col from '../../common/Col';

type Props = {
  variant?: 'primary' | 'secondary';
  className?: string;
  id?: string;
  children: ReactNode;
};

export const SimplePill = ({variant = 'primary', className, ...rest}: Props) => (
  <Col
    className={classNames(
      'w-fit m-auto border-normal rounded-full px-lg py-xs overflow-hidden',
      'justify-center items-center text-xl',
      variant === 'secondary'
        ? 'border-primary-300 shadow-solid-green bg-primary-600 text-white'
        : 'border-gray-100 shadow-solid-light-green bg-white text-primary-700',
      className
    )}
    {...rest}
  />
);
